import dayjs from 'dayjs';

import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/pt-br';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.locale('pt-br');

export const formatDate = (
  date?: string | Date | dayjs.Dayjs,
  format = 'YYYY-MM-DD'
) => {
  if (!date) return undefined;
  return dayjs(date).format(format);
};

export const normalizeApiDateOnly = (value: unknown): unknown => {
  if (!value) return value;

  if (typeof value === 'string') {
    const isoDateMatch = value.match(/^(\d{4}-\d{2}-\d{2})/);
    if (isoDateMatch?.[1]) return isoDateMatch[1];
  }

  const formatted = dayjs(value as string | Date | dayjs.Dayjs).format('YYYY-MM-DD');
  return formatted === 'Invalid Date' ? value : formatted;
};

export default dayjs;
